import {Action, ActionReducer, createReducer, on} from '@ngrx/store';
import * as CoreActions from './core.actions';
import {INotification} from '../../../shared-utilities/models-old/datastructures';
import {IDataTimeStamps, IFromAppQueueItem} from '../models';
import {IGlobalError} from '../../../shared/shared-components/components/global-error-display/models/global-error';

export interface CoreState {
  dataTimeStamps: Record<string, IDataTimeStamps>;
  errors: IGlobalError[];
  fromAppQueue: IFromAppQueueItem[];
  images: Record<string, string>;
  isFromAppQueueLoading: boolean;
  isUserMessageCountLoading: boolean;
  userMessages: INotification[];
  userMessagesCount: number;
}

export const initialCoreState: CoreState = {
  errors: [],
  fromAppQueue: [],
  images: {},
  isFromAppQueueLoading: false,
  isUserMessageCountLoading: false,
  userMessagesCount: 0,
  userMessages: [],
  dataTimeStamps: {},
};

const createCoreReducer: ActionReducer<CoreState> = createReducer(
  initialCoreState,
  // ====================================================================================================
  // Get Image URL
  // ====================================================================================================
  on(CoreActions.getImageURL, (state: CoreState, {path, image}) => {
    const images = {...state.images};
    if (images[image]) {
      delete images[image];
    }
    return {
      ...state,
      images,
    };
  }),
  on(CoreActions.getImageURLSuccess, (state: CoreState, {url, image}) => {
    const images = {...state.images};
    images[image] = url;
    return {
      ...state,
      images,
    };
  }),
  on(CoreActions.getImageURLFailure, (state: CoreState, {error}) => {
    return {
      ...state,
      errors: [...state.errors, error],
    };
  }),
  // ====================================================================================================
  // User Messages
  // ====================================================================================================

  on(CoreActions.setIsUserMessageCountLoading, (state: CoreState, {isLoading}) => ({
    ...state,
    isUserMessageCountLoading: isLoading,
  })),
  on(CoreActions.getUserMessagesSuccess, (state: CoreState, {messages}) => ({
    ...state,
    isUserMessageCountLoading: false,
    userMessages: messages,
    userMessagesCount: messages.length,
  })),
  on(CoreActions.getUserMessagesFailure, (state: CoreState, {error}) => ({
    ...state,
    isUserMessageCountLoading: false,
    errors: [...state.errors, error],
  })),
  on(CoreActions.getFromAppQueue, (state: CoreState) => ({
    ...state,
    isFromAppQueueLoading: true,
  })),
  on(CoreActions.getFromAppQueueSuccess, (state: CoreState, {items}) => ({
    ...state,
    fromAppQueue: items,
    isFromAppQueueLoading: false,
  })),
  on(CoreActions.getFromAppQueueFailure, (state: CoreState, {error}) => ({
    ...state,
    errors: [...state.errors, error],
    isFromAppQueueLoading: false,
  })),
  on(CoreActions.getDataTimeStampsSuccess, (state, {store, dataTimeStamps}) => {
    return {
      ...state,
      dataTimeStamps: {
        ...state.dataTimeStamps,
        [store.storeId]: dataTimeStamps,
      },
    };
  }),
  on(CoreActions.getDataTimeStampsAsAdminSuccess, (state, {dataTimeStamps}) => {
    return {
      ...state,
      dataTimeStamps: {
        ...state.dataTimeStamps,
        ...dataTimeStamps,
      },
    };
  }),
  on(CoreActions.getDataTimeStampsFailure, (state, {error}) => ({
    ...state,
    errors: [...state.errors, error],
  })),
);

export const coreReducer = (state: CoreState, action: Action): CoreState => createCoreReducer(state, action);
